import { cn } from '@/lib/utils';

interface TaliLogoProps {
  language?: 'ar' | 'en';
  className?: string;
  inverse?: boolean;
}

export function TaliLogo({ language = 'ar', className, inverse = false }: TaliLogoProps) {
  const suffix = language === 'ar' ? 'ar' : 'en';
  const alt = language === 'ar' ? 'تالي' : 'TALI';

  return (
    <span className={cn('tali-logo-motion relative inline-flex shrink-0 items-center', className)}>
      {inverse ? (
        <img
          src={`/brand/tali-logo-${suffix}-white.svg`}
          alt={alt}
          className="tali-logo-image h-full w-auto object-contain"
        />
      ) : (
        <>
          <img
            src={`/brand/tali-logo-${suffix}.svg`}
            alt={alt}
            className="tali-logo-image h-full w-auto object-contain dark:hidden"
          />
          <img
            src={`/brand/tali-logo-${suffix}-white.svg`}
            alt=""
            aria-hidden="true"
            className="tali-logo-image hidden h-full w-auto object-contain dark:block"
          />
        </>
      )}
    </span>
  );
}
